export default "__VITE_ASSET__CcHdZDbX__"